import React from 'react';
import { colors } from '../../styles/styles';

/**
 * A reusable component for displaying the number of selected items
 */
const SelectedCounter = ({ count, style = {} }) => {
  return (
    <span style={{
      fontSize: '14px',
      fontWeight: '500',
      color: colors.textSecondary,
      lineHeight: '38px',
      ...style
    }}>
      {count} selected
    </span>
  );
};

export default SelectedCounter; 